import type { CoaTemplateActivityEventResult } from "./coaTemplateActivityEvents";

export type CoaUndoBlockedReasonCategory =
    | "changed"
    | "postApplyActivity"
    | "inUse"
    | "generic";

export function getEventBlockedUndoReasonCategory(
    event: CoaTemplateActivityEventResult | undefined,
): CoaUndoBlockedReasonCategory {
    if (!event || event.status === "error") {
        return "generic";
    }
    const categories = event.eligibility.items
        .filter((item) => !item.eligible)
        .map((item): CoaUndoBlockedReasonCategory => {
            if (item.reason === "post_apply_activity") {
                return "postApplyActivity";
            }
            if (
                item.reason === "changed_since_applied" ||
                item.reason === "missing"
            ) {
                return "changed";
            }
            if (item.reason === "in_use") {
                return "inUse";
            }
            return "generic";
        });
    const effectiveCategories: CoaUndoBlockedReasonCategory[] = event
        .eligibility.superseded
        ? [...categories, "changed"]
        : categories;
    return getBlockedUndoReasonCategory(effectiveCategories);
}

export function getBlockedUndoReasonCategory(
    categories: CoaUndoBlockedReasonCategory[],
): CoaUndoBlockedReasonCategory {
    const [firstCategory] = categories;
    return firstCategory &&
        categories.every((category) => category === firstCategory)
        ? firstCategory
        : "generic";
}
